import { Box, Fab, Typography, createStyles, makeStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import React from 'react';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        active: function (props) { return ({
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
            },
            backgroundColor: props.current ? theme.palette.primary.main : theme.palette.common.white,
            borderColor: theme.palette.primary.main,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: 'none',
            color: !props.current ? theme.palette.primary.main : theme.palette.common.white,
            fontWeight: theme.typography.fontWeightBold,
        }); },
        container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            fontWeight: theme.typography.fontWeightBold,
            justifyContent: 'center',
            width: 150,
        },
        disabled: {
            '&:active': {
                boxShadow: 'none',
            },
            '&:hover': {
                backgroundColor: theme.palette.common.white,
                color: fade(theme.palette.primary.light, 0.5),
            },
            backgroundColor: theme.palette.common.white,
            borderColor: fade(theme.palette.primary.light, 0.5),
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: 'none',
            color: fade(theme.palette.primary.light, 0.5),
            cursor: 'not-allowed',
            fontWeight: theme.typography.fontWeightBold,
        },
        disabledText: {
            color: fade(theme.palette.primary.light, 0.5),
        },
        typo: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _a),
    });
});
export default (function (_a) {
    var id = _a.id, name = _a.name, active = _a.active, current = _a.current, style = _a.style, onClick = _a.onClick;
    var styles = useStyles({ active: active, current: current });
    var handleClick = function () {
        if (active) {
            if (onClick) {
                onClick();
            }
        }
    };
    return (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: 150, fontWeight: 500, style: style },
        React.createElement(Fab, { onClick: handleClick, size: "small", className: !active && !current ? styles.disabled : styles.active, disableRipple: !active && !current }, id),
        React.createElement(Typography, { display: "inline", color: "primary", className: !active && !current ? styles.disabledText + " " + styles.typo : styles.typo, style: { opacity: !active && !current ? 0.8 : 1 } }, name)));
});
//# sourceMappingURL=index.js.map